import { getProductCategories } from "@hardware/Services/CustomProductService";
import {uploadOrderFiles} from "@hardware/Services/FileUploadService";
import { setGA4Event } from "@hardware/Store/Handlers/Utilities/CustomTracking";
import {CustomState} from "@hardware/Store/Reducers";
import { addToChainBefore } from "@insite/client-framework/HandlerCreator";
import {chain,ExecuteOnSuccessCallback} from "@insite/client-framework/Store/Pages/CheckoutReviewAndSubmit/Handlers/PlaceOrder";

addToChainBefore(chain, ExecuteOnSuccessCallback, async props => {
    const state = props.getState() as CustomState;
    const form = new FormData();   

    const result = await getProductCategories({
        productIds: props.apiParameter.cart.cartLines
            ?.filter(line => line.productId !== null && line.productId !== undefined)
            .map(line => line.productId!) || [], // Ensure productIds is always an array
        type: "product",
    });

    if (result.successful) {
        const categories = result.result.productProperties[0].categories;
        const brand = result.result.productProperties[0].brandName;
        const pageCategoryId = result.result.productProperties[0].id;
        const productCategories = result.result.productProperties;
        const carrier = props.apiParameter.cart.carrier;
        const cart = props.apiParameter.cart;
        const billTo = props.apiResult.billTo;
        const shipTo = props.apiResult.shipTo;
        const orderNumber = props.apiResult.cart.orderNumber;
        
        // Add null check for props.apiResult.cartLines
        if (props.apiParameter.cart.cartLines) {
             setGA4Event("add_shipping_info", props.apiParameter.cart.cartLines, { categories, brand, pageCategoryId, productCategories, carrier});
             setGA4Event("add_payment_info", props.apiParameter.cart.cartLines, { categories, brand, pageCategoryId, productCategories, carrier, cart});
             setGA4Event("purchase", props.apiParameter.cart.cartLines, { categories, brand, pageCategoryId, productCategories, carrier, cart,billTo, shipTo, orderNumber});
            
            }
    }

    try {
         form.append("orderNumber", props.apiResult.cart.orderNumber);
        if (state.orderFileUpload.file) {
            form.append("file", state.orderFileUpload.file);
            form.append("fileName", state.orderFileUpload.file.name);
        }

        if (state.orderFileUpload.file == null) {
            return;
        }

        const apiResult: string = await uploadOrderFiles(form);

        if (apiResult.toLocaleLowerCase() === "success") {
            // eslint-disable-next-line no-console
            console.log("Files upload successful");
        }
    } catch (error) {
        if ("errorMessage" in error) {
            // eslint-disable-next-line no-console
            console.log("Files upload failed", error.errorMessage);
        }

        return false;
    }

});
